import { render, staticRenderFns } from "./wxOfficialSubstitute.vue?vue&type=template&id=3ac35bec&scoped=true"
import script from "./wxOfficialSubstitute.vue?vue&type=script&lang=js"
export * from "./wxOfficialSubstitute.vue?vue&type=script&lang=js"
import style0 from "./wxOfficialSubstitute.vue?vue&type=style&index=0&id=3ac35bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac35bec",
  null
  
)

export default component.exports